export default [{
        "gaosu": "124926",
        "guodao": "121556",
        "name": "北京",
        "qitadao": "107922",
        "shengdao": "231905",
        "total": "924408",
        "xiandao": "149744",
        "xiangzhendao": "188355"
    },
    {
        "gaosu": "480845",
        "guodao": "293040",
        "name": "天津",
        "qitadao": "226795",
        "shengdao": "660154",
        "total": "1984560",
        "xiandao": "146867",
        "xiangzhendao": "176859"
    }, {
        "gaosu": "2867067",
        "guodao": "5237799",
        "name": "河北",
        "qitadao": "1576936",
        "shengdao": "8008058",
        "total": "20336011",
        "xiandao": "1377014",
        "xiangzhendao": "1269137"
    }, {
        "gaosu": "945041",
        "guodao": "3289528",
        "name": "山西",
        "qitadao": "1016155",
        "shengdao": "4814431",
        "total": "11266114",
        "xiandao": "681073",
        "xiangzhendao": "519886"
    }, {
        "gaosu": "1956588",
        "guodao": "4058373",
        "name": "河南",
        "qitadao": "1145245",
        "shengdao": "7353938",
        "total": "16442925",
        "xiandao": "803975",
        "xiangzhendao": "1124806"
    }, {
        "gaosu": "2094685",
        "guodao": "5152338",
        "name": "山东",
        "qitadao": "1816951",
        "shengdao": "7958807",
        "total": "20361260",
        "xiandao": "1846224",
        "xiangzhendao": "1492255"
    }, {
        "gaosu": "583006",
        "guodao": "120777",
        "name": "上海",
        "qitadao": "208971",
        "shengdao": "406818",
        "total": "2124420",
        "xiandao": "478023",
        "xiangzhendao": "326825"
    }, {
        "gaosu": "2122523",
        "guodao": "2294342",
        "name": "江苏",
        "qitadao": "594930",
        "shengdao": "2051947",
        "total": "9227338",
        "xiandao": "1148019",
        "xiangzhendao": "1015577"
    }, {
        "gaosu": "2354613",
        "guodao": "1045592",
        "name": "浙江",
        "qitadao": "153899",
        "shengdao": "1064709",
        "total": "6014801",
        "xiandao": "839106",
        "xiangzhendao": "556882"
    }, {
        "gaosu": "583120",
        "guodao": "623734",
        "name": "福建",
        "qitadao": "80375",
        "shengdao": "365395",
        "total": "1906930",
        "xiandao": "124910",
        "xiangzhendao": "129396"
    }, {
        "gaosu": "1917762",
        "guodao": "1361065",
        "name": "安徽",
        "qitadao": "77863",
        "shengdao": "2080391",
        "total": "6251398",
        "xiandao": "466475",
        "xiangzhendao": "347842"
    }, {
        "gaosu": "1218154",
        "guodao": "1510166",
        "name": "江西",
        "qitadao": "43908",
        "shengdao": "856913",
        "total": "4106474",
        "xiandao": "190843",
        "xiangzhendao": "286490"
    }, {
        "gaosu": "1850343",
        "guodao": "1477531",
        "name": "湖北",
        "qitadao": "398584",
        "shengdao": "1674592",
        "total": "6148149",
        "xiandao": "291115",
        "xiangzhendao": "455984"
    }, {
        "gaosu": "2344438",
        "guodao": "1193352",
        "name": "湖南",
        "qitadao": "80456",
        "shengdao": "1317220",
        "total": "5852920",
        "xiandao": "372501",
        "xiangzhendao": "544953"
    }, {
        "gaosu": "2831918",
        "guodao": "3275550",
        "name": "广东",
        "qitadao": "291472",
        "shengdao": "2839070",
        "total": "11540146",
        "xiandao": "745917",
        "xiangzhendao": "1556219"
    }, {
        "gaosu": "924525",
        "guodao": "2176591",
        "name": "广西",
        "qitadao": "138293",
        "shengdao": "765031",
        "total": "4778441",
        "xiandao": "365523",
        "xiangzhendao": "408478"
    }, {
        "gaosu": "299070",
        "guodao": "299911",
        "name": "贵州",
        "qitadao": "141516",
        "shengdao": "357947",
        "total": "1512136",
        "xiandao": "206699",
        "xiangzhendao": "206993"
    }, {
        "gaosu": "918993",
        "guodao": "1027092",
        "name": "云南",
        "qitadao": "221552",
        "shengdao": "790721",
        "total": "3632936",
        "xiandao": "324777",
        "xiangzhendao": "349801"
    }, {
        "gaosu": "150216",
        "guodao": "128784",
        "name": "海南",
        "qitadao": "39683",
        "shengdao": "95640",
        "total": "492733",
        "xiandao": "21409",
        "xiangzhendao": "57001"
    }, {
        "gaosu": "304023",
        "guodao": "709798",
        "name": "黑龙江",
        "qitadao": "98790",
        "shengdao": "490080",
        "total": "2233134",
        "xiandao": "279360",
        "xiangzhendao": "351083"
    }, {
        "gaosu": "272623",
        "guodao": "1181727",
        "name": "吉林",
        "qitadao": "177949",
        "shengdao": "759522",
        "total": "2773615",
        "xiandao": "179169",
        "xiangzhendao": "202625"
    }, {
        "gaosu": "1109442",
        "guodao": "2869239",
        "name": "辽宁",
        "qitadao": "278052",
        "shengdao": "2234125",
        "total": "8033886",
        "xiandao": "868915",
        "xiangzhendao": "674113"
    }, {
        "gaosu": "1523769",
        "guodao": "1751809",
        "name": "陕西",
        "qitadao": "1428211",
        "shengdao": "1399125",
        "total": "7794977",
        "xiandao": "934272",
        "xiangzhendao": "757791"
    }, {
        "gaosu": "424283",
        "guodao": "494987",
        "name": "新疆",
        "qitadao": "606556",
        "shengdao": "564243",
        "total": "2426175",
        "xiandao": "101689",
        "xiangzhendao": "234417"
    }, {
        "gaosu": "222787",
        "guodao": "1412359",
        "name": "内蒙古",
        "qitadao": "452179",
        "shengdao": "858294",
        "total": "3986768",
        "xiandao": "597000",
        "xiangzhendao": "444149"
    }, {
        "gaosu": "90477",
        "guodao": "572063",
        "name": "青海",
        "qitadao": "110987",
        "shengdao": "150369",
        "total": "1033706",
        "xiandao": "30894",
        "xiangzhendao": "78916"
    }, {
        "gaosu": "142521",
        "guodao": "654926",
        "name": "宁夏",
        "qitadao": "397935",
        "shengdao": "605635",
        "total": "1998094",
        "xiandao": "96699",
        "xiangzhendao": "100378"
    }, {
        "gaosu": "313532",
        "guodao": "727404",
        "name": "甘肃",
        "qitadao": "303865",
        "shengdao": "316197",
        "total": "1956254",
        "xiandao": "92319",
        "xiangzhendao": "202937"
    }, {
        "gaosu": "0",
        "guodao": "115284",
        "name": "西藏",
        "qitadao": "681",
        "shengdao": "23209",
        "total": "155154",
        "xiandao": "3091",
        "xiangzhendao": "12889"
    }, {
        "gaosu": "1597510",
        "guodao": "1236161",
        "name": "四川",
        "qitadao": "407588",
        "shengdao": "1299704",
        "total": "6656726",
        "xiandao": "1429480",
        "xiangzhendao": "686283"
    }, {
        "gaosu": "1037271",
        "guodao": "306387",
        "name": "重庆",
        "qitadao": "166365",
        "shengdao": "825137",
        "total": "2802187",
        "xiandao": "159892",
        "xiangzhendao": "307135"
    }
]